/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o="esri-navigation-toggle",t={base:o,isLayoutHorizontal:`${o}--horizontal`};export{t as css};
